export default __webpack_public_path__ + "static/media/minecraft.bba52776.jpg";